import { get } from 'lodash'


function isPublishedToAGS(distributionLinks, filename) {

  var foundAGSLink = false

  if (filename.endsWith('.sd')){
    if (distributionLinks != null) {
      distributionLinks.map(distributionLink => {
        let uri = get(distributionLink, 'uri', null)

        if (uri.includes('gis.usgs.gov') || uri.includes('sciencebase.gov/arcgis')) {
          foundAGSLink = true
        }
      })
    }
  }


  return foundAGSLink
}


export {
  isPublishedToAGS
}
